<template lang="pug">

	.animated.fadeIn
		b-list-group
			sessionsListItem(v-for="session in sess" :key="session.id" :_sessionItem="session" :_participantID="participantID" :_toggle="toggle")

</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import sessionsListItem from '../Event/components/sessionsListItem'

	export default {
		name: 'sessions-component',
		props: ['sess', 'eventID', 'participantID'],
		components:{
			sessionsListItem
		},
		data: () => ({
			dateRegExp: "HH:MM",
		}),
		computed: {
			...mapState(['myParticipant']),

			activeSessions() { return this.myParticipant.data.session },
		},
		methods: {
			...mapActions(['getMyParticipant']),
			...mapActions(['addSessionToSchedule', 'removeSessionFromSchedule']),

			isActive(session){ return this.activeSessions.some(item=>item.id===session.id) },
			getVariant(session){ return this.isActive(session) ? 'success' : 'light'; },

			async updateContext(){
				if ( this.participantID ) await this.$store.dispatch('getMyParticipant', {id: this.participantID});
			},
			async toggle(e,sessionId,remove=false){
				e.preventDefault();
				remove
					? await this.$store.dispatch('removeSessionFromSchedule', { id:sessionId, event:this.eventID })
					: await this.$store.dispatch('addSessionToSchedule', { id:sessionId, event:this.eventID });

				await this.updateContext();
			},
		},
	}
</script>

<style scoped>

</style>
